<template>
  <v-container fluid class="ma-4 pa-4">
    <v-row class="mx-4">
      <v-col lg="8">
        <v-row>
          <v-col class="px-0">
            <h1 class="text-h4">{{ $t("contact.contactForm") }}</h1>
            <p class="caption">(* {{ $t("contact.requiredFields") }})</p>
          </v-col>
        </v-row>
        <template>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <form @submit.prevent="submit">
              <v-col>
                <v-row align="center" justify="space-between">
                  <v-col cols="12" md="3" class="py-0">
                    <v-radio-group class="mx-4 my-2" v-model="Mr_Mrs" row>
                      <v-radio
                        class="my-1"
                        :key="$t('contact.neutral')"
                        :label="$t('contact.neutral')"
                        :value="$t('contact.neutral')"
                      >
                      </v-radio>
                      <v-radio
                        class="my-1"
                        :key="$t('contact.sir')"
                        :label="$t('contact.sir')"
                        :value="$t('contact.sir')"
                      >
                      </v-radio>
                      <v-radio
                        class="my-1"
                        :key="$t('contact.madam')"
                        :label="$t('contact.madam')"
                        :value="$t('contact.madam')"
                      >
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="4" class="py-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="firstName"
                      rules="required|max:20"
                      style="width: 100%"
                    >
                      <v-text-field
                        v-model="firstName"
                        :error-messages="errors"
                        :label="$t('contact.firstName')"
                        required
                        outlined
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="5" class="py-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="lastName"
                      rules="required|max:30"
                    >
                      <v-text-field
                        v-model="lastName"
                        :error-messages="errors"
                        :label="$t('contact.lastName')"
                        required
                        outlined
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row align="center" justify="space-between">
                  <v-col cols="12" md="3" class="py-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="company"
                      rules="required|max:20"
                    >
                      <v-text-field
                        v-model="company"
                        :error-messages="errors"
                        :label="$t('contact.company')"
                        required
                        outlined
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="4" class="py-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="profession"
                      rules="max:20"
                    >
                      <v-text-field
                        v-model="profession"
                        :error-messages="errors"
                        :label="$t('contact.profession')"
                        outlined
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="5" class="py-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="email"
                      rules="required|email"
                    >
                      <v-text-field
                        v-model="email"
                        :error-messages="errors"
                        :label="$t('contact.email')"
                        required
                        outlined
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row align="center" justify="space-between">
                  <v-col cols="12" md="3" class="py-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="postalCode"
                      rules="max:15"
                    >
                      <v-text-field
                        v-model="postalCode"
                        :error-messages="errors"
                        :label="$t('contact.postalCode')"
                        outlined
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="4" class="py-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="city"
                      rules="max:20"
                    >
                      <v-text-field
                        v-model="city"
                        :error-messages="errors"
                        :label="$t('contact.city')"
                        outlined
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="5" class="py-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="phoneNumber"
                      :rules="{
                        regex: '^(\\+33)(6|7)\\d{8}$',
                      }"
                    >
                      <v-text-field
                        v-model="phoneNumber"
                        :error-messages="errors"
                        :label="`${$t('contact.phone')}`"
                        outlined
                      >
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <validation-provider v-slot="{ errors }" name="adresse">
                  <v-text-field
                    v-model="address"
                    :error-messages="errors"
                    :label="$t('contact.address')"
                    class="my-4"
                    outlined
                  ></v-text-field>
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  name="message"
                  rules="required|max:300"
                >
                  <v-textarea
                    outlined
                    v-model="message"
                    :counter="300"
                    :error-messages="errors"
                    label="Message *"
                    required
                    class="my-4"
                  >
                  </v-textarea>
                </validation-provider>
                <v-row align="center" justify="end">
                  <v-btn
                    depressed
                    color="primary"
                    class="mr-4"
                    type="submit"
                    @click="send()"
                    :disabled="invalid"
                  >
                    {{ $t("contact.send") }}
                  </v-btn>
                  <v-btn depressed small color="primary" text @click="clear">
                    {{ $t("contact.reset") }}
                  </v-btn>
                </v-row>
              </v-col>
            </form>
          </validation-observer>
        </template>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      app
      tile
      right
      light
      elevation="0"
      rounded
    >
      <v-alert type="success" border="right" color="primary" dark v-if="sent">
        {{ $t("contact.infoSuccess") }}
      </v-alert>
      <v-alert type="error" border="right" color="secondary" dark v-else>
        {{ $t("contact.infoError") }}
      </v-alert>
    </v-snackbar>
  </v-container>
</template>

<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
  configure,
} from "vee-validate";
import { mapGetters } from "vuex";
import { monitore } from "../components/helpers/helpers";

import i18n from "../i18n";

setInteractionMode("eager");

configure({
  defaultMessage: (field, values) => {
    return i18n.t(`contact.validation.${values._rule_}`, values);
  },
});

extend("required", required);

extend("max", max);

extend("regex", {
  ...regex,
  message: "Format : +33611223344",
});

extend("email", email);

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    Mr_Mrs: "",
    firstName: "",
    lastName: "",
    company: "",
    profession: "",
    email: "",
    postalCode: "",
    city: "",
    phoneNumber: "",
    address: "",
    message: "",
    snackbar: false,
    timeout: 1500,
    invalid: true,
    sent: false,
  }),
  beforeMount() {
    this.Mr_Mrs = this.$t("contact.neutral");
  },
  mounted() {
    if (this.user.access_token) {
      this.fetchUserInfo();
    }
  },
  computed: {
    ...mapGetters(["user", "identity"]),
  },
  methods: {
    submit() {
      this.$refs.observer.validate();
    },
    clear() {
      this.Mr_Mrs = this.$t("contact.neutral");
      this.firstName = "";
      this.lastName = "";
      this.company = "";
      this.profession = "";
      this.email = "";
      this.postalCode = "";
      this.city = "";
      this.phoneNumber = "";
      this.address = "";
      this.message = "";
      this.resetInvalid;
    },
    resetInvalid() {
      this.invalid = true;
      this.$refs.observer.reset();
    },
    fetchUserInfo() {
      this.firstName = this.identity.name.split(" ")[0];
      this.lastName = this.identity.name.split(" ")[1];
      this.email = this.identity.email;
      this.company = this.identity.company;
      this.Mr_Mrs = this.$t("contact.neutral");
    },

    // api to send message
    async send() {
      try {
        let url = "/contacts";
        const response = await this.axios({
          method: "post",
          url: url,
          data: {
            Mr_Mrs: this.Mr_Mrs,
            firstName: this.firstName,
            lastName: this.lastName,
            company: this.company,
            profession: this.profession,
            email: this.email,
            postalCode: this.postalCode,
            city: this.city,
            phoneNumber: this.phoneNumber,
            address: this.address,
            message: this.message,
          },
        });
        if (response.status === 200) {
          this.sent = true;
          monitore("Send contact request");
        } else {
          this.sent = false;
        }
      } catch (err) {
        console.error(err);
        // this.confirm = true;
        this.sent = false;
        // this.loading = false;
      }
      this.snackbar = true;
    },
  },
  watch: {
    message(val) {
      if (val !== null && val.length > 5) {
        this.submit();
      }
    },
  },
};
</script>
